import {
  Box,
  Card,
  Checkbox,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { FunctionComponent, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getNotes } from '../api/getNotes';
import { removeNote } from '../api/removeNote';
import { AddNoteButton } from './AddNoteButton';
import { EditNoteButton } from './EditNoteButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Note } from '../types/note';
import DeleteIcon from '@mui/icons-material/Delete';

export const NotesPage: FunctionComponent<{}> = () => {
  const { isLoading, data: notes } = useQuery('notes', getNotes);
  const [selected, setSelected] = useState<Note | undefined>();

  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const deleteMutation = useMutation(removeNote, {
    onSuccess: () => {
      queryClient.invalidateQueries('notes');
      setSelected(undefined);
    },
  });

  return (
    <div>
      {isLoading ? (
        'loading...'
      ) : (
        <Card>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mx: 2,
              mt: 1,
              mb: 0,
            }}
          >
            <Typography>Notes</Typography>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {selected && (
                <>
                  <EditNoteButton id={selected.id} />

                  <IconButton onClick={() => deleteMutation.mutate(selected)}>
                    <DeleteIcon />
                  </IconButton>
                </>
              )}

              <AddNoteButton />
            </Box>
          </Box>
          <List sx={{ width: 300 }}>
            {notes?.map((n) => (
              <React.Fragment key={n.id}>
                <Divider />
                <ListItem
                  secondaryAction={
                    <IconButton onClick={() => navigate(`/notes/${n.id}`)}>
                      <VisibilityIcon />
                    </IconButton>
                  }
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      tabIndex={-1}
                      disabled={selected && selected.id !== n.id}
                      onChange={(e) =>
                        setSelected(e.target.checked ? n : undefined)
                      }
                    />
                  </ListItemIcon>
                  <ListItemText primary={n.title} />
                </ListItem>
              </React.Fragment>
            ))}
          </List>
        </Card>
      )}
    </div>
  );
};
